import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  CreateRoleInterface,
  RoleInterface,
  UpdateRoleInterface
} from '@thro-types/access-handler';

import { AxiosRequestConfig } from 'axios';

import { createRole, deleteRole, getRoles, updateRole } from 'api/accessHandlerService';

export const useRolesQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['roles', config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      const roles = getRoles(config);
      return roles;
    },
    placeholderData: keepPreviousData
  });

  return query;
};

export const useRoleMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['roles'];

  const create = useMutation<RoleInterface, Error, CreateRoleInterface>({
    mutationFn: async args => {
      return await createRole(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<RoleInterface, Error, { id: number; data: UpdateRoleInterface }>({
    mutationFn: async args => {
      return await updateRole(args.id, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const deletion = useMutation<RoleInterface, Error, number>({
    mutationFn: async args => {
      return await deleteRole(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { create, update, deletion } as const;
};
